import Page from 'shared/components/Page'
import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

export const StyledPage = styled(Page)`
  && > div > span {
    margin: 0px;
  }
`
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: space-between;
  background-color: ${colors.blue};
`

export const Term = styled.div`
  height: 45vh;
  padding: 10px;
  border: 3px solid ${colors.white};
  overflow-y: scroll;

  p {
    color: ${colors.white};
  }

  span {
    color: ${colors.white};
  }

  li {
    color: ${colors.white};
  }

  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px transparent;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background: ${colors.white};
    border-radius: 10px;
  }
`

export const ContainerTerms = styled.div`
  width: 80%;
  display: flex;
  flex-direction: column;
`
